import { createSelector } from 'reselect';
import { CustomModelAssumptionsState } from './reducer';

const selectCustomModelAssumptions: (state: any) => CustomModelAssumptionsState = state =>
  state.AdviserSettings.CustomModelAssumptions;

export const selectAssetClasses = createSelector(
  selectCustomModelAssumptions,
  ({ assetClasses }) => assetClasses,
);

export const selectIncludedAssetClasses = createSelector(selectAssetClasses, assetClasses =>
  assetClasses.filter(({ included }) => included),
);

export const selectAssetClassesIndexedById = createSelector(selectAssetClasses, assetClasses =>
  assetClasses.reduce((acc, assetClass) => ({ ...acc, [assetClass.id]: assetClass }), {}),
);

export const selectReturns = createSelector(selectCustomModelAssumptions, ({ returns }) => returns);

export const selectVolatilities = createSelector(
  selectCustomModelAssumptions,
  ({ volatilities }) => volatilities,
);

export const selectCorrelations = createSelector(
  selectCustomModelAssumptions,
  ({ correlations }) => correlations,
);

export const selectCmaType = createSelector(selectCustomModelAssumptions, ({ cmaType }) => cmaType);

const selectEditable = createSelector(selectCustomModelAssumptions, ({ editable }) => editable);

export const selectEditableAssetClasses = createSelector(
  selectEditable,
  ({ assetClasses }) => assetClasses,
);

export const selectEditableReturns = createSelector(selectEditable, ({ returns }) => returns);

export const selectEditableVolatilities = createSelector(
  selectEditable,
  ({ volatilities }) => volatilities,
);
